import { useState } from 'react';
import Modal from 'react-modal';
import { ArrowRightCircle } from 'react-bootstrap-icons';
import symbol1 from "../assets/img/nummer-1.png";
import symbol2 from "../assets/img/nummer-2.png";
import symbol3 from "../assets/img/nummer-3.png";

Modal.setAppElement('#root'); // Accessibility-Fix (nur einmal im Projekt nötig)

export const Consulting = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', text: '' });

  const openModal = (title, text) => {
    setModalContent({ title, text });
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <section className="container consulting anchor-offset" id="consulting">
      <h2>Beratung</h2>
      <article>Vom Altbau bis zum Neubau: Wir finden die beste Lösung für dich!</article>

      <div className="con-slider-wrapper">
        <div className="con-box" onClick={() => openModal('Telefonische Beratung', 'Wir sind gern für dich da und beraten dich persönlich zu energieeffizienten Maßnahmen und deinen gesetzlichen Anforderungen. Gemeinsam schauen wir, wie du Energie sparst und dir attraktive Förderungen von BAFA und KfW sicherst, egal ob beim Heizungstausch oder rund ums Thema Photovoltaik.')}>
          <div className="imageContainer">
            <img className="symbol" src={symbol1} alt="" />
          </div>
          <div>
            <h3>Telefonische Beratung</h3>
              <p>
                Wir sind gerne für dich da und berate dich persönlich zu energieeffizienten Maßnahmen&nbsp;
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    display: 'inline',
                    cursor: 'pointer',
                    verticalAlign: 'middle',
                  }}
                >
                  <ArrowRightCircle size={20} />
                </button>
              </p>
          </div>
        </div>

        <div className="con-box" onClick={() => openModal('Sanierungsfahrplan', 'Mit einem individuellen Sanierungsfahrplan bekommst du von uns eine maßgeschneiderte Strategie für die energetische Sanierung deines Hauses. Wir kommen persönlich vorbei, schauen uns alles genau an, finden Schwachstellen und entwickeln einen klaren Plan, natürlich mit Blick auf passende Fördermittel. Und das Beste: Du sicherst dir damit zusätzlich 5 Prozent mehr Förderung für deine Maßnahmen.')}>
          <div className="imageContainer">
            <img className="symbol" src={symbol2} alt="" />
          </div>
          <div>
            <h3>Sanierungsfahrplan</h3>
            <p>Bei einer persönlichen Beratung vor Ort entwickeln wir einen Individuellen Plan für dich&nbsp;
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    display: 'inline',
                    cursor: 'pointer',
                    verticalAlign: 'middle',
                  }}
                >
                  <ArrowRightCircle size={20} />
                </button>
              </p>
          </div>
        </div>

        <div className="con-box" onClick={() => openModal('Baubegleitung', 'Egal ob Sanierung oder Neubau, wir begleiten dich von Anfang an. Gemeinsam planen wir energieeffiziente Maßnahmen und achten darauf, dass alles fachgerecht umgesetzt wird. So sicherst du dir nicht nur attraktive Förderungen, sondern sparst auch langfristig Energie und Kosten. Übrigens: Bei der KfW-Effizienzhausförderung ist unsere Baubegleitung sogar Pflicht und für dich ein echter Mehrwert.')}>
          <div className="imageContainer">
            <img className="symbol" src={symbol3} alt="" />
          </div>
          <div>
            <h3>Baubegleitung</h3>
            <p>Egal ob Sanierung oder Neubau, wir begleiten dich von Anfang an&nbsp;
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    display: 'inline',
                    cursor: 'pointer',
                    verticalAlign: 'middle',
                  }}
                >
                  <ArrowRightCircle size={20} />
                </button>
              </p>
          </div>
        </div>
      </div>

      {/* Modal Popup */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Detailinfo"
        className="popup-modal"
        overlayClassName="popup-overlay"
      >
        <h2>{modalContent.title}</h2>
        <p>{modalContent.text}</p>
        <button onClick={closeModal}>Schließen</button>
      </Modal>
    </section>
  );
};
